export const TRANSITION_CSS = 'transition: all 0.15s ease-in-out';
